export default "__VITE_ASSET__CKbILu4c__"